import React from 'react'
import CommunityPostsListing from './CommunityPostsListing'

const CommunityPlayerOfTheRound = () => (
  <CommunityPostsListing
    postType="player_of_round"
    title="Player of the Round Posts"
    subtitle="The standout player highlighted after each round."
  />
)

export default CommunityPlayerOfTheRound
